import React, {useState} from 'react';
import logo from '../img/logo.png'
import Container from './Container'
import NavBar from './NavBar';


const Header = () => {
	const [darken, setDarken] = useState(window.pageYOffset > 50);

	const links = [
		{
			href: "#whatis",
			txt: "Что это такое?"
		},
		{
			href: "#access",
			txt: "Доступ"
		},
		{
			href: "#contact",
			txt: "Контакты"
		},
	]

	const style = {
		width: '100%',
		position: "fixed",
		top: "0",
	}

	window.addEventListener('scroll', e => {
		if (window.pageYOffset > 50)
		{
			if (darken === false)
				setDarken(true);
		}
		else if (darken === true)
			setDarken(false);
	})
	
	return <div className={"Header" + (darken? " dark" : "")} style={ style }>
		<Container flex justifySpace>
			<a href="#top">
				<img src={ logo } alt="Alternative Tycoon logo" height="80px" />
			</a> 
			<NavBar links={links} />
		</Container>
	</div>
}

export default Header